import './partials/DharmaModal';
import './partials/CartPageModal';
import StorageService from './lib/storage.service';

const lastAddedUrl = StorageService.get('last-added-url');
if (lastAddedUrl && lastAddedUrl !== '') {
  const continueBtn = document.querySelector('.cart__continue');
  continueBtn?.setAttribute('href', lastAddedUrl);
}

// corrects qunatities for bolts and cases when there is not enough stock to fullfill bolt/case
const checkAndCorrectQuantities = () => {
  const quantitySelectors = document.querySelectorAll('quantity-selector');
  quantitySelectors.forEach(qs => {
    const increment = parseInt(qs.getAttribute('increment-by'));
    if (increment) {
      const value = parseInt(qs.querySelector('input').value);
      const correctedValue = Math.floor(value/increment) * increment;
      if (value !== correctedValue) {
        console.log('checkAndCorrectQuantities:', 'value', value, 'increment', increment, 'correctedValue', correctedValue);
        document.dispatchEvent(
          new CustomEvent('cart:quantity', {
            detail: [qs.key, correctedValue, qs]
          })
        );
      }
    }
  });
}

document.addEventListener('cart:updated', (e) => {
  setTimeout(() => {
    checkAndCorrectQuantities();
  }, 1000);
});

/* document.addEventListener('cart:quantity', (e) => {
  console.log(e.detail);
}); */

setTimeout(() => {
  checkAndCorrectQuantities();
}, 1000);
